import {pipe} from 'ramda'
import Global from './modules/global';
import Accordion from './modules/accordion';
import Button from './modules/button';
import Header from './modules/header';
import lazyLoad from './modules/lazyLoad';
import modal from './modules/modal';
import Awards from './modules/awards';
import Events from './modules/events';
import PostList from './modules/post-list';
import Testimonials from './modules/testimonials';


pipe(
    Global,
    Accordion,
    Button,
    Header,
    lazyLoad,
    modal,
    Awards,
    Events,
    PostList,
    Testimonials,
)();



// WEBPACK FOOTER //
// ../src/scripts/global.js